<template>
    <div class="">
        <!-- 页面标题和批量操作 -->
        <div class="section-header">
            <div class="headerLeft">
                <span class="line"></span>
                我的关注
            </div>
            <div class="batch-operation">
                <!-- 非批量模式显示批量操作按钮 -->
                <el-button type="primary" size="small" @click="toggleBatchMode" v-if="!isBatchMode">批量操作</el-button>

                <!-- 批量模式显示全选和取消关注按钮 -->
                <div v-else>
                    <el-checkbox v-model="isAllSelected" @change="handleAllSelect"
                        style="margin-right: 10px;">全选</el-checkbox>
                    <el-button type="danger" size="small" @click="handleBatchUnfollow"
                        :disabled="selectedItems.length === 0">取消关注</el-button>
                    <el-button type="text" size="small" @click="toggleBatchMode"
                        style="margin-left: 10px;">取消</el-button>
                </div>
            </div>
        </div>

        <!-- 关注店铺列表 -->
        <div class="follows-list" v-if="followedShops.length > 0">
            <div class="follow-item" v-for="(shop, index) in followedShops" :key="index">
                <!-- 批量模式下显示选择复选框 -->
                <div v-if="isBatchMode" class="select-checkbox-wrapper">
                    <el-checkbox v-model="selectedItems" :label="shop.store_id"
                        @change="handleItemSelect"></el-checkbox>
                </div>

                <!-- 店铺信息 -->
                <div class="shop-info">
                    <div class="shop-avatar">
                        <img :src="shop.store_logo" :alt="shop.name">
                    </div>
                    <div class="shop-details">
                        <div class="shop-name">{{ shop.store_name }}</div>
                        <div class="shop-rating">
                            <div class="stars">
                                <i class="el-icon-star-on" v-for="n in 5" :key="n"
                                    :style="{ color: n <= shop.store_star ? '#F7BA2A' : '#E0E0E0' }"></i>
                            </div>
                            <span class="followers">{{ shop.follow_num }}人关注</span>
                        </div>
                    </div>
                    <div class="shop-actions">
                        <el-button type="default" size="small">联系客服</el-button>
                        <el-button type="primary" size="small" @click="enterShop(shop)">进店逛逛</el-button>
                    </div>
                </div>

                <!-- 店铺商品 -->
                <div class="shop-products">
                    <div class="product-item" v-for="(product, pIndex) in shop.goods_list" :key="pIndex"
                        @click="enterGoodsDetail(product)">
                        <div class="product-image">
                            <img :src="product.goods_thumb" :alt="product.name">
                        </div>
                        <div class="product-price">
                            <span class="price-symbol">¥</span>
                            <span class="price-value">{{ product.shop_price }}</span>
                            <!-- <span class="price-unit">{{ product.unit }}</span> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <el-empty description="暂无关注店铺"></el-empty>
        </div>


        <!-- 分页控件 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="totalOrders">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MyFollows',
    data() {
        return {
            followedShops: [],

            // 批量操作相关数据
            isBatchMode: false, // 是否处于批量操作模式
            selectedItems: [], // 选中的店铺ID列表
            isAllSelected: false, // 是否全选

            // 分页数据
            currentPage: 1,
            pageSize: 10,
            totalOrders: 0,
        }
    },
    mounted() {
        this.getMyShopFollowList();
    },
    methods: {
        // 联系客服
        contactService() {
            console.log('联系客服');
        },

        // 进店逛逛
        enterShop() {
            console.log('进店逛逛');
        },

        // 获取我的店铺关注列表
        getMyShopFollowList() {
            let data = {
                page: this.currentPage,
                list_rows: this.pageSize,
            }
            this.$api.getMyShopFollowList(data).then(res => {
                this.followedShops = res.data || [];
                this.totalOrders = res.total || 0;
            }).catch(err => {
                this.$message.error(err.msg);
                console.log(err);
            })
        },

        // 跳转店铺详情页
        enterShop(shop) {
            this.$router.push({
                path: '/StoreDetails',
                query: {
                    id: shop.store_id,
                }
            })
        },

        //跳转商品详情页
        enterGoodsDetail(product) {
            this.$router.push({
                path: '/ShopDetails',
                query: {
                    id: product.goods_id,
                }
            })
        },

        // 批量操作方法
        // 切换批量操作模式
        toggleBatchMode() {
            this.isBatchMode = !this.isBatchMode;
            if (!this.isBatchMode) {
                // 退出批量模式时清空选择
                this.selectedItems = [];
                this.isAllSelected = false;
            }
        },

        // 处理单个店铺选择
        handleItemSelect() {
            // 当没有店铺时，直接返回
            if (this.followedShops.length === 0) {
                this.isAllSelected = false;
                return;
            }

            // 更新全选状态：当选中的店铺数量等于所有店铺数量时，全选状态为true
            this.isAllSelected = this.selectedItems.length === this.followedShops.length;
        },

        // 处理全选
        handleAllSelect() {
            if (this.isAllSelected) {
                // 全选：将所有店铺的store_id添加到selectedItems数组
                this.selectedItems = this.followedShops.map(shop => shop.store_id);
            } else {
                // 取消全选：清空selectedItems数组
                this.selectedItems = [];
            }
        },

        // 批量取消关注
        handleBatchUnfollow() {
            if (this.selectedItems.length === 0) {
                return;
            }
            // 这里可以添加批量取消关注的API调用
            console.log('批量取消关注的店铺ID:', this.selectedItems);
            this.cancleGuanzhuShop(this.selectedItems)

            // // 假设API调用成功后，从列表中移除选中的店铺
            // this.followedShops = this.followedShops.filter(shop => !this.selectedItems.includes(shop.store_id));
            // this.selectedItems = [];
            // this.isAllSelected = false;
            // this.$message.success('批量取消关注成功');
        },

        // 取消关注店铺
        cancleGuanzhuShop(shop) {
            this.$dapi.cancleGuanzhuShop({
                shop_id: shop.toString(),
            }).then(res => {
                this.$message.success('取消关注成功');
                this.getMyShopFollowList();
            }).catch(err => {
                this.$message.error(err.msg);
                console.log(err);
            })
        },

        // 分页方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.selectedItems = [];
            this.isAllSelected = false;
            this.getMyShopFollowList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.selectedItems = [];
            this.isAllSelected = false;
            this.getMyShopFollowList();
        },
    }
}
</script>

<style scoped>
.member-center {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    padding: 20px;
}

/* 页面标题 */
.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.headerLeft {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
}

.line {
    display: block;
    width: 4px;
    height: 18px;
    background-color: #286CED;
    border-radius: 2px;
    margin-right: 12px;
}

/* 批量操作按钮 */
.batch-operation .el-button {
    padding: 6px 16px;
    font-size: 14px;
}

/* 关注列表 - 修改为每行2个店铺的网格布局 */
.follows-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.follow-item {
    /* flex: 1 1 calc(50% - 10px); */
    width: 46%;
    /* 每行2个，减去间隙的一半 */
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 16px;
    transition: all 0.3s ease;
    box-sizing: border-box;
    position: relative;
}

/* 选择复选框样式 */
.select-checkbox-wrapper {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 10;
}

.follow-item:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 店铺信息 */
.shop-info {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    gap: 12px;
    flex-wrap: wrap;
}

.shop-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
}

.shop-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.shop-details {
    flex: 1;
    min-width: 120px;
}

.shop-name {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    margin-bottom: 4px;
    text-align: left;
}

.shop-rating {
    display: flex;
    align-items: center;
    gap: 8px;
}

.stars {
    display: flex;
    gap: 2px;
}

.stars i {
    font-size: 12px;
}

.followers {
    font-size: 12px;
    color: #999999;
}

.shop-actions {
    display: flex;
    gap: 8px;
}

.shop-actions .el-button {
    padding: 4px 12px;
    font-size: 12px;
}

/* 店铺商品 */
.shop-products {
    display: flex;
    gap: 12px;
    overflow-x: auto;
    padding-bottom: 8px;
}

.shop-products::-webkit-scrollbar {
    height: 6px;
}

.shop-products::-webkit-scrollbar-track {
    background-color: #f5f5f5;
    border-radius: 3px;
}

.shop-products::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 3px;
}

.product-item {
    min-width: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.product-image {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 6px;
}

.product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.product-item:hover .product-image img {
    transform: scale(1.05);
}

.product-price {
    font-size: 14px;
    color: #ff4d4f;
    font-weight: 600;
}

.price-symbol {
    font-size: 12px;
}

.price-unit {
    font-size: 12px;
    margin-left: 2px;
}

/* 隐藏复选框的label文本 */
:deep(.el-checkbox__label) {
    display: none !important;
}

/* 分页容器 */
.pagination-container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    text-align: right;
    text-align: center;

}


/* 响应式设计 */
@media (max-width: 768px) {
    .follow-item {
        flex: 1 1 100%;
        /* 小屏幕下每行显示1个 */
    }

    .shop-info {
        flex-direction: column;
        align-items: flex-start;
    }

    .shop-actions {
        margin-top: 8px;
    }

    .shop-products {
        gap: 8px;
    }

    .product-item {
        min-width: 70px;
    }

    .product-image {
        width: 70px;
        height: 70px;
    }
}

@media (max-width: 480px) {
    .section-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }
}
</style>